import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTransactionMethods } from "../../redux/actions/lookups/getTransactionMethods";
import { PaymentTypeMap } from "../../helper";

const useTransactionMethods = (setLoading) => {
  const dispatch = useDispatch();
  const { transferMethods } = useSelector(
    (state) => state.getTransactionMethods
  );
  const [transferType, setTransferType] = useState([]);

  useEffect(() => {
    if (!transferMethods || transferMethods.length === 0) {
      setLoading(true);
      dispatch(getTransactionMethods())
        .then((methods) => setTransferType(methods))
        .catch((error) =>
          console.error("Error fetching transaction method:", error)
        );
      setLoading(false);
    } else {
      setTransferType(transferMethods);
    }
    // eslint-disable-next-line
  }, [transferMethods]);

  const getMethodBylable = (label) => {
    if (transferMethods && transferMethods.length > 0) {
      const method = transferMethods.find((method) => method.name === label);
      // console.log("Method found:", method, label);
      return method ? method : "";
    }
    return null;
  };


  const mappedTransferTypes = transferType.map((type) => ({
    label: PaymentTypeMap[type.name] || type.name,
    value: type.id,
  }));

  return [mappedTransferTypes, getMethodBylable];
};

export default useTransactionMethods;
